﻿export default class RecommendedType {

  static RecommendedPaid() {
    return new RecommendedType('recommendedScreen');
  }

  static RecommendedBasic() {
    return new RecommendedType('recommendedScreenBasic');
  }

  constructor(type) {
    this.type = type;
  }

  getName() {
    return this.type;
  }
}
